import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "CARDREQUESTS";
export const cardRequestConstants = createCRUDConstants(nameSpace, ["GETSTATUS"]);

export const retrynameSpace = "RETRYCARDREQUEST";
export const retryConstants = createCRUDConstants(retrynameSpace);
export const successNameSpace = "SUCESSCARDREQUEST";
export const successConstants = createCRUDConstants(successNameSpace);
export const requestStatus = [
    {
        name: "REQUEST_VALIDATION_FAILED",
        actualName: "VALIDATION FAILED",
        bg: "red",
        fontColor: "#fff",
        description: "A required field is not sent or it can’t find one or more of the objects sent in the request",
    },
    {
        name: "REQUEST_PRODUCTION_FAILED",
        actualName: "PRODUCTION FAILED",
        // bg: "#FF7733",
        // fontColor: "#fff",
        bg: "red",
        fontColor: "#fff",
        description: "The call to produce the card(s) failed",
        shortCode: "RPF",
    },
    {
        name: "REQUEST_SCHEDULED_FOR_PERSONALIZATION",
        actualName: "SCHEDULED FOR PERSONALIZATION",
        bg: "green",
        fontColor: "#fff",
        description: "Card(s) has been produced and a preparation job has been scheduled on SCP. At this point, the card is already produced",
        shortCode: "RSFP",
    },
    {
        name: "REQUEST_PERSONALIZATION_FAILED",
        actualName: "PERSONALIZATION FAILED",
        bg: "red",
        fontColor: "#fff",
        // bg: "#FFC433",
        // fontColor: "inherit",
        description: "Preparation job failed.",
        shortCode: "RPpF",
    },
    {
        name: "REQUEST_UPLOAD_FAILED",
        actualName: "UPLOAD FAILED",
        bg: "red",
        fontColor: "#fff",
        description: "There is a failure to upload the card data to the perso company. The file can always be downloaded from SCP",
        shortCode: "RUF",
    },
    {
        name: "REQUEST_UPLOADED_TO_PERSO",
        actualName: "UPLOADED TO PERSO",
        bg: "green",
        fontColor: "#fff",
        description: "Card data is successfully uploaded to the perso SFTP location and this is the final step in our flow",
        shortCode: "RUTP",
    },
    {
        name: "REQUEST_FAILED",
        actualName: "SYSTEM FAILURE ON SCP",
        bg: "red",
        fontColor: "#fff",
        description: "There is a system failure on SCP (cases like exceptions been thrown by some methods)",
        shortCode: "RF",
    },
    
];
